const state = {
  font: {
    default: "Roboto",
    family: [
      "Arial",
      "Bradley Hand ITC",
      "Calibri",
      "Georgia",
      "Gill Sans",
      "Helvetica",
      "Impact",
      "Lucida Calligraphy",
      "Palatino Linotype",
      "Roboto",
      "Tahoma",
      "Times New Roman",
      "Trebuchet MS",
      "Vivaldi",
    ],
    size: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
  },
};

export default {
  state,
};
